import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, inject, AfterViewInit, Injector, runInInjectionContext } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { fromEvent, merge } from "rxjs";
import { debounceTime, distinctUntilChanged, tap } from "rxjs/operators";
import { PyrocastLogsDataSource } from "../services/data-sources/pyrocast-logs.datasource";
import { SelectionModel } from '@angular/cdk/collections';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-pyrocast-logs',
    templateUrl: './pyrocast-logs.component.html',
    styleUrls: ['./pyrocast-logs.component.scss'],
    standalone: false,
    providers: [PyrocastLogsDataSource]
})
export class PyrocastLogsComponent implements OnInit, AfterViewInit {

    // 1. Angular ka core Injector pakadyein taake asynchronous callbacks me use kar sakein
    private injector = inject(Injector);

    // 2. Data Source ko Angular standard provider ke zariye inject karein
    public dataSource = inject(PyrocastLogsDataSource);

    displayedColumns: string[] = [
        "sn",
        "id",
        'name',
    ];
    selection = new SelectionModel<number>(true, []);
    bulkAction = '';
    currentPageCount = 0;
    count = 0;

    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    @ViewChild('search') search!: ElementRef;

    constructor(
        public dialog: MatDialog,
        private _snackBar: MatSnackBar, 
        private ref: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.dataSource.currentPageCount$.subscribe(currentPageCount => {
            this.currentPageCount = currentPageCount;
        });
        this.dataSource.count$.subscribe(count => {
            this.count = count;
        });
    }

    ngAfterViewInit() {

        this.sort.sort(({ id: 'name', start: 'desc' }) as MatSortable);
        this.ref.detectChanges();

        // 2. Initial load ab automatically trigger ho jayega ya fir aap manually ek baar call karein
        this.loadPage();
        
        fromEvent(this.search.nativeElement, 'keyup')
            .pipe(
                debounceTime(150),
                distinctUntilChanged(),
                tap(() => {
                    this.paginator.pageIndex = 0;
                    this.loadPage();
                })
            )
            .subscribe();

        merge(this.sort.sortChange, this.paginator.page)
            .pipe(
                tap(() => this.loadPage())
            )
            .subscribe();
            
        this.sort.sort(({ id: 'name', start: 'desc' }) as MatSortable);
        this.ref.detectChanges();
    }

    loadPage() {
        // 3. FIX: Pure list execution ko injection context ke sath force karein.
        // Is se keyup, filter, ya page change par NG0203 error bilkul nahi aayega.
        runInInjectionContext(this.injector, () => {
            this.dataSource.list(
                {
                    search: this.search.nativeElement.value,
                },
                this.sort.active,
                this.sort.direction,
                this.paginator.pageIndex + 1,
                this.paginator.pageSize
            );
        });
    }
}